import { Link } from "react-router-dom";
import { Upload } from "lucide-react";
import { Button } from "@/components/ui/button";
import { portalHref } from "@/features/portal/portal-base";

/** Left column of the home hero: reassurance badge, greeting, and the primary
 * "upload a document" call to action. */
export function WelcomeHero({
  clientName,
  firmName,
  outstanding,
}: {
  clientName: string;
  firmName: string;
  outstanding: number;
}) {
  const firstName = clientName.trim().split(/\s+/)[0] || clientName;
  const thing = outstanding === 1 ? "one small thing" : `${outstanding} small things`;

  return (
    <div className="flex flex-col justify-center gap-4 py-2">
      <span className="bg-success-soft text-success inline-flex w-fit items-center gap-2 rounded-full px-3 py-1.5 text-sm font-semibold">
        <span className="bg-success size-2 rounded-full" />
        Your case is in good hands
      </span>
      <h1 className="text-4xl leading-[1.05] font-bold tracking-tight text-foreground sm:text-[2.75rem]">
        Welcome back, {firstName}.
      </h1>
      <p className="text-muted-foreground max-w-xl text-lg">
        {outstanding > 0 ? (
          <>
            You're almost done. Just <strong className="text-foreground">{thing}</strong> left and
            your tax team{firmName ? ` at ${firmName}` : ""} can get to work.
          </>
        ) : (
          <>You're all caught up — your tax team has everything they need right now.</>
        )}
      </p>
      <div className="mt-1 flex flex-wrap items-center gap-4">
        <Button asChild variant="cta" size="lg">
          <Link to={portalHref("/documents/upload")}>
            <Upload className="size-5" />
            Upload a document
          </Link>
        </Button>
        <span className="text-muted-foreground text-sm">
          Takes about 2 minutes · Photos from your phone work too
        </span>
      </div>
    </div>
  );
}
